import React from 'react';
import classNames from 'classnames';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DeleteButton from 'Components/ComponentLibrary/Atoms/Buttons/DeleteButton';
import ListItem2 from 'Components/ComponentLibrary/Components/ListItems/ListItem2';
import ListItemText1 from 'Components/ComponentLibrary/Components/Uncategorized/ListItemText/ListItemText1';
import ListItemSecondaryAction
  from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemSecondaryAction';

const styles = () => ({
  root: {},
  listItemDisabled: {
    pointerEvents: 'none',
  },
});

const DynamicItemCard = ({
  className, classes, name, description, subtext, onCardClick, onRemove, color,
}) => {
  return (
    <>
      <ListItem2
        className={classNames(className, classes.root, { [classes.listItemDisabled]: !onCardClick })}
        test={`dynamic-card-list-item-${name}`}
        color={color}
        button
        onClick={onCardClick}
      >
        <ListItemText1
          primary={name}
          secondary={description}
        />
        <ListItemSecondaryAction>
          {onRemove != null && (
            <DeleteButton
              onClick={onRemove}
              test={`dynamic-item-card-delete-${name}`}
            />
          )}
        </ListItemSecondaryAction>
      </ListItem2>
      {subtext && (
        <Text text={subtext} weight={'bold'} variant={'fineprint'} align={'left'} color={'error'} />
      )}
    </>
  );
};

DynamicItemCard.defaultProps = {
  description: '',
  onCardClick: null,
  onRemove: null,
  className: null,
  subtext: null,
  color: undefined,
};

DynamicItemCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  subtext: PropTypes.string,
  onCardClick: PropTypes.func,
  onRemove: PropTypes.func,
  color: PropTypes.string,
};

export default withStyles(styles)(DynamicItemCard);
